import styled from 'styled-components';
export var Container = styled.div.withConfig({
  componentId: "sc-1e2zbfg-0"
})(["display:flex;flex-direction:column;"]);